/*import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CartPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const navigate = useNavigate();

  // Simulate fetching cart items from storage/context
  useEffect(() => {
    // In a real app, this would come from context or local storage
    const mockCartItems = [
      {
        id: 1,
        name: 'Margherita Pizza',
        restaurant: 'Pizza Palace',
        image: 'assets/images/c5.jpg',
        price: 12.99,
        quantity: 1
      },
      {
        id: 2,
        name: 'Chicken Biryani',
        restaurant: 'Spice Garden',
        image: 'assets/images/c6.jpg',
        price: 14.99,
        quantity: 2
      },
      {
        id: 3,
        name: 'Caesar Salad',
        restaurant: 'Fresh & Healthy',
        image: 'assets/images/c7.jpeg',
        price: 8.99,
        quantity: 1
      }
    ];

    setCartItems(mockCartItems);
    calculateTotal(mockCartItems);
  }, []);

  const calculateTotal = (items) => {
    const total = items.reduce((sum, item) => {
      return sum + (item.price * item.quantity);
    }, 0);
    setTotalPrice(total);
  };

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) return;

    const updatedItems = cartItems.map(item => {
      if (item.id === id) {
        return { ...item, quantity: newQuantity };
      }
      return item;
    });

    setCartItems(updatedItems);
    calculateTotal(updatedItems);
  };

  const removeItem = (id) => {
    const updatedItems = cartItems.filter(item => item.id !== id);
    setCartItems(updatedItems);
    calculateTotal(updatedItems);
  };

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      alert('Your cart is empty!');
      return;
    }
    navigate('/checkout');
  };

  return (
    <div className="cart-page">
      <div className="cart-header">
        <h1>Your Cart</h1>
        {cartItems.length > 0 ? (
          <p>{cartItems.length} items in your cart</p>
        ) : (
          <p>Your cart is empty</p>
        )}
      </div>

      {cartItems.length > 0 ? (
        <div className="cart-content">
          <div className="cart-items">
            {cartItems.map(item => (
              <div className="cart-item" key={item.id}>
                <div className="item-image">
                  <img src={item.image} alt={item.name} />
                </div>
                <div className="item-details">
                  <h3>{item.name}</h3>
                  <p className="restaurant-name">{item.restaurant}</p>
                  <p className="item-price">${item.price.toFixed(2)}</p>
                </div>
                <div className="item-quantity">
                  <button 
                    className="quantity-btn" 
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button 
                    className="quantity-btn" 
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  >
                    +
                  </button>
                </div>
                <div className="item-total">
                  <p>${(item.price * item.quantity).toFixed(2)}</p>
                </div>
                <button 
                  className="remove-btn"
                  onClick={() => removeItem(item.id)}
                >
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h2>Order Summary</h2>
            <div className="summary-row">
              <span>Subtotal:</span>
              <span>${totalPrice.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Delivery Fee:</span>
              <span>$3.99</span>
            </div>
            <div className="summary-row">
              <span>Tax:</span>
              <span>${(totalPrice * 0.08).toFixed(2)}</span>
            </div>
            <div className="summary-row total">
              <span>Total:</span>
              <span>${(totalPrice + 3.99 + (totalPrice * 0.08)).toFixed(2)}</span>
            </div>

            <button 
              className="btn btn-primary checkout-btn"
              onClick={handleCheckout}
            >
              Proceed to Checkout
            </button>

            <Link to="/" className="continue-shopping">
              Continue Shopping
            </Link>
          </div>
        </div>
      ) : (
        <div className="empty-cart">
          <div className="empty-cart-image">
            <i className="fa fa-shopping-cart"></i>
          </div>
          <h2>Your cart is empty</h2>
          <p>Looks like you haven't added anything to your cart yet.</p>
          <Link to="/" className="btn btn-primary">
            Browse Restaurants
          </Link>
        </div>
      )}
    </div>
  );
};

export default CartPage;*/

/*code updated  */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CartPage = () => {
  const [cartItems, setCartItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  useEffect(() => {
    if (!isLoggedIn) {
      alert('Please log in to view your cart');
      navigate('/login');
    }
  }, []);
  useEffect(() => {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      try {
        const parsed = JSON.parse(storedCart);
        const items = parsed.products ?? parsed; // fallback if products not wrapped
        setCartItems(items);
        calculateTotal(items);
      } catch (err) {
        console.error('Error parsing cart:', err);
      }
    }
  }, []);

  const calculateTotal = (items) => {
    const total = items.reduce((sum, item) => {
      const price = item.finalPrice ?? item.price ?? 0;
      return sum + price * item.quantity;
    }, 0);
    setTotalPrice(total);
  };

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) return;
    const updatedItems = cartItems.map(item =>
      item.product_id === id ? { ...item, quantity: newQuantity } : item
    );
    setCartItems(updatedItems);
    localStorage.setItem('cart', JSON.stringify({ products: updatedItems }));
    calculateTotal(updatedItems);
  };

  const removeItem = (id) => {
    const updatedItems = cartItems.filter(item => item.product_id !== id);
    setCartItems(updatedItems);
    localStorage.setItem('cart', JSON.stringify({ products: updatedItems }));
    calculateTotal(updatedItems);
  };

  const handleCheckout = () => {
    if (cartItems.length === 0) {
      alert('Your cart is empty!');
      return;
    }
    navigate('/checkout');
  };

  return (
    <div className="cart-page container py-4">
      <div className="cart-header mb-4">
        <h1>Your Cart</h1>
        <p>{cartItems.length > 0 ? `${cartItems.length} item(s) in your cart` : 'Your cart is empty'}</p>
      </div>

      {cartItems.length > 0 ? (
        <div className="row">
          {/* Cart Items */}
          <div className="col-md-8">
            {cartItems.map(item => (
              <div className="cart-item d-flex p-3 border rounded mb-4 align-items-start">
                <img
                  src={item.image || "/assets/images/default.jpg"}
                  alt={item.name}
                  className="rounded"
                  style={{ width: "100px", height: "100px", objectFit: "cover", marginRight: "20px" }}
                />

                <div className="flex-grow-1">
                  <h5 className="mb-1">{item.name}</h5>

                  {item.options?.length > 0 && (
                    <ul className="mb-2">
                      {item.options.map((opt, i) => (
                        <li key={i} style={{ fontSize: "14px" }}>
                          {opt.name}: {opt.choice} {opt.price !== 0 && `(+${opt.price.toFixed(2)})`}
                        </li>
                      ))}
                    </ul>
                  )}

                  <p className="mb-1"><strong>Price:</strong> ${item.finalPrice?.toFixed(2) ?? item.price?.toFixed(2)}</p>

                  <div className="d-flex align-items-center gap-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => updateQuantity(item.product_id, item.quantity - 1)}>-</button>
                    <span>{item.quantity}</span>
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => updateQuantity(item.product_id, item.quantity + 1)}>+</button>
                  </div>
                </div>

                <div className="text-end" style={{ marginLeft: "auto" }}>
                  <h6 className="text-danger fw-bold">Total: ${(item.quantity * (item.finalPrice ?? item.price)).toFixed(2)}</h6>
                  <button className="btn btn-sm btn-outline-danger mt-2" onClick={() => removeItem(item.product_id)}>
                    <i className="fa fa-trash"></i> Remove
                  </button>
                </div>
              </div>

            ))}
          </div>

          {/* Order Summary */}
          <div className="col-md-4 cart-summary-total">
            <div className="cart-summary border rounded p-3">
              <h4>Order Summary</h4>
              <div className="summary-row d-flex justify-content-between">
                <span>Subtotal:</span>
                <span>${totalPrice.toFixed(2)}</span>
              </div>
              <div className="summary-row d-flex justify-content-between">
                <span>Delivery Fee:</span>
                <span>$3.99</span>
              </div>
              <div className="summary-row d-flex justify-content-between">
                <span>Tax (8%):</span>
                <span>${(totalPrice * 0.08).toFixed(2)}</span>
              </div>
              <hr />
              <div className="summary-row d-flex justify-content-between fw-bold">
                <span>Total:</span>
                <span>${(totalPrice + 3.99 + (totalPrice * 0.08)).toFixed(2)}</span>
              </div>

              <button className="btn btn-primary w-100 mt-3" onClick={handleCheckout}>
                Proceed to Checkout
              </button>
              <Link to="/" className="btn btn-link w-100 mt-2">
                Continue Shopping
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center my-5">
          <i className="fa fa-shopping-cart fa-3x mb-3"></i>
          <h3>Your cart is empty</h3>
          <p>Looks like you haven't added anything yet.</p>
          <Link to="/" className="btn btn-primary">
            Browse Restaurants
          </Link>
        </div>
      )}
    </div>
  );
};

export default CartPage;
